import * as THREE from 'three';
import { asphaltSurface, concreteSurface } from './SurfaceTextures.js';

export function wetAsphaltMaterial(wetness = 0.62, repeat: [number, number] = [5, 12]): THREE.MeshPhysicalMaterial {
  const maps = asphaltSurface();
  for (const map of Object.values(maps)) map.repeat.set(...repeat);
  return new THREE.MeshPhysicalMaterial({
    color: 0x9299aa,
    map: maps.map,
    roughnessMap: maps.roughnessMap,
    normalMap: maps.normalMap,
    normalScale: new THREE.Vector2(0.32, 0.32),
    roughness: THREE.MathUtils.lerp(0.88, 0.34, wetness),
    metalness: 0.04,
    clearcoat: wetness * 0.5,
    clearcoatRoughness: 0.26,
  });
}

export function concreteMaterial(tint = 0x8b91a0, repeat: [number, number] = [4, 2]): THREE.MeshStandardMaterial {
  const maps = concreteSurface();
  for (const map of Object.values(maps)) map.repeat.set(...repeat);
  return new THREE.MeshStandardMaterial({
    color: tint,
    map: maps.map,
    roughnessMap: maps.roughnessMap,
    normalMap: maps.normalMap,
    normalScale: new THREE.Vector2(0.42, 0.42),
    roughness: 0.88,
    metalness: 0,
  });
}

export function paintedMetalMaterial(color: number, roughness = 0.26): THREE.MeshPhysicalMaterial {
  return new THREE.MeshPhysicalMaterial({
    color,
    roughness,
    metalness: 0.48,
    clearcoat: 0.9,
    clearcoatRoughness: 0.2,
  });
}

export function darkMetalMaterial(color = 0x12151c, roughness = 0.46): THREE.MeshStandardMaterial {
  return new THREE.MeshStandardMaterial({ color, roughness, metalness: 0.72 });
}

export function rubberMaterial(): THREE.MeshStandardMaterial {
  return new THREE.MeshStandardMaterial({ color: 0x08090c, roughness: 0.94, metalness: 0 });
}

export function glassMaterial(): THREE.MeshPhysicalMaterial {
  return new THREE.MeshPhysicalMaterial({
    color: 0x07131d,
    roughness: 0.12,
    metalness: 0.05,
    transmission: 0.18,
    transparent: true,
    opacity: 0.72,
    clearcoat: 1,
    clearcoatRoughness: 0.08,
    side: THREE.DoubleSide,
  });
}

export function emissiveMaterial(color: number, intensity = 3): THREE.MeshStandardMaterial {
  return new THREE.MeshStandardMaterial({
    color,
    emissive: color,
    emissiveIntensity: intensity,
    roughness: 0.2,
    metalness: 0.08,
    toneMapped: false,
  });
}
